export enum TYPE_TABLE {
	Daily = "daily",
	Weekly = "weekly",
	Monthly = "monthly"
}

export enum TIMELINE_DURATION {
	Year = 12,
	TwoYears = 24,
	HalfYear = 6
}
